// @ts-nocheck
import React, { forwardRef, useEffect, useState, useCallback } from 'react';

import { InputProps, styled } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import InputMask from 'react-input-mask';

import { numbersToTime } from '../../utils/dates';

export const StyledInput = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '8px',
  border: `2px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.background.paper,
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
  },
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  height: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1),
    height: '100%',
    width: '100%',
    fontWeight: 600,
    textAlign: 'center',
  },
}));

const checkTimeInput = (time: string) => {
  if (!time) {
    return '';
  }
  const timeItems = time.split(':');
  if (+timeItems[0] > 24) {
    timeItems[0] = `0${timeItems[0].substring(0, 1)}`;
  }
  if (+timeItems[1] > 60) {
    timeItems[1] = `0${timeItems[1].substring(0, 1)}`;
  }
  return timeItems.join(':');
};

const formatValue = (time: string): string => {
  if (!time || time === 'N/A') {
    return '';
  }
  const timeItems = time.split(':');
  const hours = +timeItems[0];
  const minutes = +timeItems[1];

  // Only format if we have valid numbers
  if (isNaN(hours) || isNaN(minutes)) {
    return time;
  }

  return numbersToTime(hours, minutes);
};

interface Props extends InputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const AppTimeInput = forwardRef((props: Props, ref) => {
  const { value, onChange, placeholder = 'N/A', ...otherProps } = props;
  const [mask, setMask] = useState<string>(placeholder);

  useEffect(() => {
    setMask(value ? '99:99' : placeholder);
  }, [value]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const checkedValue = checkTimeInput(e.target.value);
      // Only call onChange if the checked value is different from current value to prevent infinite loops
      if (checkedValue !== value) {
        onChange(checkedValue);
      }
    },
    [value, onChange]
  );

  const handleBlur = useCallback(() => {
    const formattedValue = formatValue(value);
    // Only call onChange if the formatted value is different to prevent infinite loops
    if (formattedValue !== value) {
      onChange(formattedValue);
    }
  }, [value, onChange]);

  const handleFocus = useCallback(() => {
    setMask('99:99');
  }, []);

  return (
    <InputMask
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleChange}
      value={value || placeholder}
      mask={mask}
      maskChar={null}
    >
      {() => (
        <StyledInput>
          <StyledInputBase inputProps={{ 'aria-label': 'search' }} innerRef={ref} {...otherProps} />
        </StyledInput>
      )}
    </InputMask>
  );
});
